import { Roles } from 'src/common/types'
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    name: 'client.settings',
    path: 'settings',
    component: () => import('src/client/pages/settings/ClientSettings.vue'),
    meta: {
      roles: [Roles.Client],
      supportedPlatforms: ['desktop', 'mobile', 'native'],
      excludeEnv: [],
    },
  },
  {
    name: 'client.settings.notifications',
    path: 'settings/notifications',
    component: () =>
      import('src/client/pages/settings/ClientSettingsNotifications.vue'),
    meta: {
      roles: [Roles.Client],
      supportedPlatforms: ['desktop', 'mobile', 'native'],
      excludeEnv: [],
    },
  },
  {
    name: 'client.settings.notifications.inapp',
    path: 'settings/notifications/inapp',
    component: () =>
      import('src/client/pages/settings/ClientSettingsNotificationsInApp.vue'),
    meta: {
      roles: [Roles.Client],
      supportedPlatforms: ['desktop', 'mobile', 'native'],
      excludeEnv: [],
    },
  },
  {
    name: 'client.settings.notifications.push',
    path: 'settings/notifications/push',
    component: () =>
      import('src/client/pages/settings/ClientSettingsNotificationsPush.vue'),
    meta: {
      roles: [Roles.Client],
      supportedPlatforms: ['desktop', 'mobile', 'native'],
      excludeEnv: [],
    },
  },
  {
    name: 'client.settings.accessibility',
    path: 'settings/accessibility',
    component: () =>
      import('src/client/pages/settings/ClientSettingsAccessibility.vue'),
    meta: {
      roles: [Roles.Client],
      supportedPlatforms: ['desktop', 'mobile', 'native'],
      excludeEnv: [],
    },
  },
]

export default routes
